
/// <amd-module name="Search/Shared/Components/SearchOverlay/SearchOverlay" />
import * as React from "react";
import * as Resources from "Search/Shared/Resources";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { ISearchOverlayProps } from "./SearchOverlay.Props";

export const SearchOverlay = (props: ISearchOverlayProps) => {
    return (
        <div className={`search-InProgress--overlay ${props.className}`}>
            <Spinner
                className="spinner"
                size={props.spinnerSize ? props.spinnerSize : SpinnerSize.medium}
                label={props.spinnerText ? props.spinnerText : Resources.LoadingMessage} />
        </div>
    );
}
